import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import ContentCard from './ContentCard';

const ContentGrid = ({ 
  selectedCategory, 
  selectedDifficulty, 
  selectedCostRange, 
  searchQuery 
}) => {
  // Mock knowledge content data
  const knowledgeContent = [
    {
      id: 1,
      title: 'Complete gids voor thuisisolatie in 2026',
      description: 'Alles wat u moet weten over het isoleren van uw woning, van vloer tot dak. Inclusief kosten, subsidies en praktische tips.',
      category: 'insulation',
      difficulty: 'intermediate',
      costRange: 'medium',
      readTime: '12 min',
      author: 'Dr. Jan Vermeulen',
      authorCredentials: 'Energie-expert, 15 jaar ervaring',
      publishDate: '2026-01-10',
      image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Isolatie', 'Subsidies', 'Energiebesparing']
    },
    {
      id: 2,
      title: 'Warmtepomp kiezen: Lucht-water vs. Bodem-water',
      description: 'Vergelijk de verschillende warmtepomp types en ontdek welke het beste bij uw situatie past.',
      category: 'renewable-energy',
      difficulty: 'beginner',
      costRange: 'high',
      readTime: '8 min',
      author: 'Lisa de Vries',
      authorCredentials: 'Duurzaamheidsadviseur',
      publishDate: '2026-01-08',
      image: 'https://images.pexels.com/photos/8853502/pexels-photo-8853502.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Warmtepomp', 'Verwarming', 'Vergelijking']
    },
    {
      id: 3,
      title: 'Subsidies en fiscale voordelen 2026 overzicht',
      description: 'Actueel overzicht van alle beschikbare subsidies, belastingvoordelen en financiële regelingen voor verduurzaming.',
      category: 'subsidies',
      difficulty: 'beginner',
      costRange: 'all',
      readTime: '15 min',
      author: 'Mark Jansen',
      authorCredentials: 'Financieel adviseur verduurzaming',
      publishDate: '2026-01-15',
      image: 'https://images.pexels.com/photos/6863332/pexels-photo-6863332.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Subsidies', 'Belasting', 'Financiering']
    },
    {
      id: 4,
      title: 'Zonnepanelen rendement berekenen: Stap voor stap',
      description: 'Leer hoe u het rendement van zonnepanelen berekent en of ze rendabel zijn voor uw woning.',
      category: 'renewable-energy',
      difficulty: 'intermediate',
      costRange: 'medium',
      readTime: '10 min',
      author: 'Sophie Bakker',
      authorCredentials: 'Zonne-energie specialist',
      publishDate: '2026-01-12',
      image: 'https://images.pexels.com/photos/9875441/pexels-photo-9875441.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Zonnepanelen', 'Rendement', 'Berekening']
    },
    {
      id: 5,
      title: 'Veelgemaakte fouten bij ventilatiesystemen',
      description: 'Vermijd deze 10 veelvoorkomende fouten bij de keuze en installatie van ventilatiesystemen.',
      category: 'energy-efficiency',
      difficulty: 'beginner',
      costRange: 'low',
      readTime: '7 min',
      author: 'Peter Hendriks',
      authorCredentials: 'Installatie-expert',
      publishDate: '2026-01-05',
      image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Ventilatie', 'Fouten', 'Tips']
    },
    {
      id: 6,
      title: 'Waterbesparing in huis: 15 praktische tips',
      description: 'Bespaar tot 40% op uw waterverbruik met deze eenvoudige maar effectieve tips en trucs.',
      category: 'water-management',
      difficulty: 'beginner',
      costRange: 'low',
      readTime: '6 min',
      author: 'Emma Visser',
      authorCredentials: 'Duurzaamheidscoach',
      publishDate: '2026-01-03',
      image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=600&fit=crop',
      verified: true,
      tags: ['Water', 'Besparing', 'Tips']
    },
    {
      id: 7,
      title: 'Thuisbatterij: Is het de investering waard?',
      description: 'Analyse van de voor- en nadelen van thuisbatterijen en wanneer ze zich terugverdienen.',
      category: 'renewable-energy',
      difficulty: 'advanced',
      costRange: 'high',
      readTime: '14 min',
      author: 'Tom de Groot',
      authorCredentials: 'Energie-opslagspecialist',
      publishDate: '2026-01-01',
      image: 'https://images.pexels.com/photos/9875365/pexels-photo-9875365.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Batterij', 'Opslag', 'ROI']
    },
    {
      id: 8,
      title: 'Energielabel verbeteren: Van D naar A in 5 stappen',
      description: 'Praktische stappenplan om het energielabel van uw woning significant te verbeteren.',
      category: 'energy-efficiency',
      difficulty: 'intermediate',
      costRange: 'medium',
      readTime: '11 min',
      author: 'Anna Smit',
      authorCredentials: 'EPA-adviseur',
      publishDate: '2025-12-28',
      image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Energielabel', 'Verbetering', 'Stappenplan']
    },
    {
      id: 9,
      title: 'HR++ glas vs. Triple glas: Wat is het verschil?',
      description: 'Vergelijk de isolatiewaarde, kosten en terugverdientijd van verschillende glassoorten.',
      category: 'insulation',
      difficulty: 'beginner',
      costRange: 'medium',
      readTime: '9 min',
      author: 'Kees van Dam',
      authorCredentials: 'Glas- en kozijnspecialist',
      publishDate: '2025-12-25',
      image: 'https://images.pexels.com/photos/1396122/pexels-photo-1396122.jpeg?auto=compress&cs=tinysrgb&w=600',
      verified: true,
      tags: ['Glas', 'Isolatie', 'Vergelijking']
    }
  ];

  // Filter content based on selected filters and search query
  const filteredContent = useMemo(() => {
    return knowledgeContent?.filter((item) => {
      const matchesCategory = selectedCategory === 'all' || item?.category === selectedCategory;
      const matchesDifficulty = selectedDifficulty === 'all' || item?.difficulty === selectedDifficulty;
      const matchesCostRange = selectedCostRange === 'all' || item?.costRange === selectedCostRange || item?.costRange === 'all';
      const matchesSearch = !searchQuery || 
        item?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        item?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        item?.tags?.some(tag => tag?.toLowerCase()?.includes(searchQuery?.toLowerCase()));
      
      return matchesCategory && matchesDifficulty && matchesCostRange && matchesSearch;
    });
  }, [selectedCategory, selectedDifficulty, selectedCostRange, searchQuery, knowledgeContent]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <p className="text-sm font-body text-muted-foreground">
            {filteredContent?.length} {filteredContent?.length === 1 ? 'artikel' : 'artikelen'} gevonden
          </p>
        </div>
        
        {filteredContent?.length > 0 ? (
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {filteredContent?.map((content) => (
              <motion.div key={content?.id} variants={cardVariants}>
                <ContentCard content={content} />
              </motion.div>
            ))}
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-16"
          >
            <p className="text-lg font-body text-muted-foreground">
              Geen artikelen gevonden met de huidige filters. Probeer andere filters.
            </p>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default ContentGrid;